import { CashFlowSummaryRowData } from './types';

export const CashFlowSummaryRowConfig = (items: CashFlowSummaryRowData[]) => [
  {
    largeHeader: true,
    ignoreRowCopy: true,
    className: 'table-header division-bottom-only'
  },
  ...(items || []),
];
